import { IReferralPersonalReportSummary } from "@finbackoffice/clientbff-client";
import { Currency } from "@finbackoffice/enums";
import { getFildNameWithCurrency } from "../../helpers";

export interface IReportSummaryData {
    baseAmount: number;
    user_payment: number;
    agent_payment: number;
}

export const getReportSummuryData = ({
    summary = [],
    isTurnoverStrategy,
    defaultCurrency,
}: {
    summary?: IReferralPersonalReportSummary[];
    isTurnoverStrategy: boolean;
    defaultCurrency: Currency;
}): IReportSummaryData => {
    return summary.reduce(
        (acc, value) => {
            const baseAmount = isTurnoverStrategy
                ? value[
                      getFildNameWithCurrency(
                          "turnover",
                          defaultCurrency,
                      ) as keyof IReferralPersonalReportSummary
                  ]
                : value[
                      getFildNameWithCurrency(
                          "profit",
                          defaultCurrency,
                      ) as keyof IReferralPersonalReportSummary
                  ];
            acc.baseAmount += Number(baseAmount || 0);
            acc.user_payment += Number(
                value[
                    getFildNameWithCurrency(
                        "amount",
                        defaultCurrency,
                    ) as keyof IReferralPersonalReportSummary
                ] || 0,
            );
            acc.agent_payment += Number(
                value[
                    getFildNameWithCurrency(
                        "agent_amount",
                        defaultCurrency,
                    ) as keyof IReferralPersonalReportSummary
                ] || 0,
            );
            return acc;
        },
        { baseAmount: 0, user_payment: 0, agent_payment: 0 },
    );
};
